import { Configuration } from '@rbx/clients';
import {
  AcceptanceApi,
  ClientType,
  RegulationType,
  AgreementType,
  AgreementResolutionApi,
} from '@rbx/clients/userAgreementsService';
import { getBEDEV2ServiceBasePath } from '@modules/utilities/constants/baseUrl';

export class UserAgreementsClient {
  private agreementResolutionApi: AgreementResolutionApi;

  private acceptanceApi: AcceptanceApi;

  constructor(basePath: string = getBEDEV2ServiceBasePath('user-agreements')) {
    const config = new Configuration({
      basePath,
      credentials: 'include',
    });

    this.agreementResolutionApi = new AgreementResolutionApi(config);
    this.acceptanceApi = new AcceptanceApi(config);
  }

  async getAssistantAgreements() {
    const res = await this.agreementResolutionApi.agreementResolutionGetByContext({
      clientType: 'CreatorAIAssistant' as unknown as ClientType,
    });
    return res;
  }

  async getPrivacyPolicyAgreements() {
    const res = await this.agreementResolutionApi.agreementResolutionGetByContext({
      clientType: ClientType.Web,
    });
    return res.filter(
      (agreement) =>
        agreement.agreementType === AgreementType.PrivacyPolicy &&
        agreement.regulationType === RegulationType.Global,
    );
  }

  async getAssistantAndPrivacyPolicyAgreements() {
    const [assistantAgreements, privacyPolicyAgreements] = await Promise.all([
      this.getAssistantAgreements(),
      this.getPrivacyPolicyAgreements(),
    ]);
    return [...assistantAgreements, ...privacyPolicyAgreements];
  }

  async acceptAgreement(agreementId: string) {
    const acceptanceInsertRequest = {
      insertAcceptancesRequest: {
        acceptances: [{ agreementId }],
      },
    };
    return this.acceptanceApi.acceptanceInsert(acceptanceInsertRequest);
  }

  async acceptAgreements(agreementIds: string[]) {
    return Promise.all(agreementIds.map((agreementId) => this.acceptAgreement(agreementId)));
  }
}

const userAgreementsClient = new UserAgreementsClient();
export default userAgreementsClient;
